import React, { useContext, useCallback } from 'react';
import styled from 'styled-components';
import { SelectField, FlexColumn, FlexMiddle } from '@ubeya/shared-web/components';
import { Avatar } from '@ubeya/shared-web/components/Avatar';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { fieldTextCss } from './createTicketStyles';
import useTicketCreationEmployeeFields from './hooks/useTicketCreationEmployeeFields';

const Container = styled(FlexColumn)`
  gap: 20px;
  padding: 24px;
  flex: 1;
  overflow-y: auto;
`;

const Heading = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0;
  color: ${({ theme }) => theme.colors.black};
`;

const OptionRow = styled(FlexMiddle)`
  gap: 8px;
  min-width: 0;
`;

const EmployeeName = styled.span`
  ${fieldTextCss};
  color: ${({ theme }) => theme.colors.black};
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const renderEmployee = ({ firstName, lastName, image, label }) => (
  <OptionRow>
    <Avatar firstName={firstName} lastName={lastName} image={image} size="xs" />
    <EmployeeName>{label}</EmployeeName>
  </OptionRow>
);

const Step1Employee = ({ onChange, onResetAttachments, lockedEmployeeId }) => {
  const { t } = useContext(ConfigContext);
  const {
    employeeOptions,
    employeeOption,
    branchOptions,
    selectedBranchOption,
    isEmployeeSelected,
    isEmployeeLocked,
    employeesLoading,
    fetchMore,
    canFetchMore,
    isFetchingMore,
    setEmployeeSearch,
    handleEmployeeChange,
    handleBranchChange
  } = useTicketCreationEmployeeFields({ onChange, onResetAttachments, lockedEmployeeId });

  const formatEmployeeOption = useCallback((option) => ({ ...option, label: renderEmployee(option) }), []);

  return (
    <Container>
      <Heading>{t('help_desk_who_is_ticket_for')}?</Heading>
      <SelectField
        name="employeeId"
        title={t('help_desk_create_for_employee')}
        options={employeeOptions}
        formatOption={formatEmployeeOption}
        isLoading={employeesLoading}
        isMulti={false}
        searchable
        disabled={isEmployeeLocked}
        setControlledSearch={setEmployeeSearch}
        onMenuScrollToBottom={canFetchMore && !isFetchingMore ? fetchMore : undefined}
        isFetchingMore={isFetchingMore}
        displayInitialValueNotInOptions={employeeOption ? [employeeOption] : []}
        onChange={handleEmployeeChange}
        usePortal
      />
      <SelectField
        name="branchId"
        title={t('branch')}
        options={branchOptions}
        isMulti={false}
        usePortal
        disabled={!isEmployeeSelected}
        displayInitialValueNotInOptions={selectedBranchOption ? [selectedBranchOption] : []}
        onChange={handleBranchChange}
      />
    </Container>
  );
};

export default Step1Employee;
